import React from 'react';
import Seo from "../components/common/Seo";
import MobileMenu from "../components/header/MobileMenu";
import menuData from "../data/MenuData";
import {NavLink} from "react-router-dom";
import HeaderBlock from "./homepage/HeaderBlock";
import FooterBlock from "./homepage/FooterBlock";

function SiteMap() {
    return (
            <>
                <Seo pageTitle="Sitemap" pageUrl={window.location.href} />
                <HeaderBlock homePage={false}/>
                <MobileMenu homePage={false}/>

                <section className="content-elements">
                    <div className="auto-container">
                        <h1>Plan du site</h1>
                        <div className="row">
                            <div className="col-12 justify-content-center">
                                <h4>Toutes les pages</h4>
                                <ul className="list-style-three">
                                    {menuData.map((item) => (
                                        item.items && item.items.length > 0 ? (
                                            <li key={item.id}>
                                                <span>{item.label}</span>
                                                <ul>
                                                    {item.items.map((subItem) => (
                                                        <li key={subItem.routePath}>
                                                            <NavLink to={`${subItem.routePath}` }>{subItem.name}</NavLink>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                        ) : (
                                            <li key={item.id}>
                                                <NavLink to={item.routePath}>
                                                    {item.label}
                                                </NavLink>
                                            </li>
                                        )
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <FooterBlock/>
            </>
    );
};

export default SiteMap;
